export default "__VITE_ASSET__IbJ18XEk__"